module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "crystal-lake-background-sat.8d73a947.jpg";